import { AccountsFilters } from '../models/accounts';

export const accountsQueries = {
  all: ['accounts'] as const,
  list: (filters: AccountsFilters) => [...accountsQueries.all, filters],
  infinityList: (filters: AccountsFilters) => [...accountsQueries.all, filters],
  detail: (id: string) => [...accountsQueries.all, 'detail', id],
};
